<div *ngIf="appInitializerService.loadingRouteConfig">
    <div class="loader"></div>
</div>
<ng-container *ngIf="!appInitializerService.loadingRouteConfig">
    <ng-content></ng-content>
</ng-container>